/**
 * © Moustapha HENNAWI - Click and Take off - 2021
 */

/*-------------------------------------------------------------------------------------------*/

import { createSlice } from '@reduxjs/toolkit';

/*-------------------------------------------------------------------------------------------*/
const { reducer, actions } = createSlice({
  name: 'users',
  initialState: {
    items: {}
  },
  reducers: {
    initial(state, action) {
      state.items = action.payload;
    },
    update(state, action) {
      action.payload.forEach(
        (item) => (state.items[state.items.findIndex((e) => e.id === item.id)] = item)
      );
    },
    delete(state, action) {
      state.items = state.items.filter((item) => item.id !== action.payload);
    }
  }
});

/*-------------------------------------------------------------------------------------------*/
export { actions as usersActions };
export { reducer as usersReducer };
/*-------------------------------------------------------------------------------------------*/
